import LogAopFactory from './LogAopFactory';
import {controllerLogList} from './ControllerConfig';
//初始化viewController的日志
const initLogViewController = function(proxyObj){
    if(process.env.NODE_ENV == 'development'){
        const proxyName = 'enterViewController=====>>>>';
        let proxy = LogAopFactory(proxyName);
        proxy.add(/^(add).*/, proxyObj).add(/^(update).*/, proxyObj).add(/^(delete).*/, proxyObj);
    }
}

//初始化controller的日志
const initLogController = function(){
    if(process.env.NODE_ENV == 'development'){
        controllerLogList.forEach((controllerLog)=>{
        const proxyName = `${controllerLog.name}=====>>>>`;
        LogAopFactory(proxyName).add('execute', controllerLog);
        });
    }
}
export {initLogViewController,initLogController}